import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { CampaignValidationService, CampaignValidationResult } from '../services/campaign-validation.service';
import { StorageService } from '../services/storage.service';

/**
 * Validates campaign access based on short code from URL or localStorage
 * Used by Experience app to ensure campaign exists and is active before loading
 */
export const validateCampaign: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const campaignValidationService = inject(CampaignValidationService);
  const storageService = inject(StorageService);
  const router = inject(Router);

  // Get short code from URL query params or localStorage fallback
  const shortCode = route.queryParams['s'] ||
                   route.queryParams['short'] ||
                   storageService.getSync('short');

  if (!shortCode) {
    return router.parseUrl('/campaign-error?status=MISSING_SHORT_CODE');
  }

  const clientId = import.meta.env['_NGX_ENV_CLIENT_ID'];
  const validation: CampaignValidationResult = await campaignValidationService.validateCampaign(shortCode, clientId);

  if (validation.isValid) {
    return true;
  }

  // Redirect to error page with validation details
  return router.parseUrl(
    `/campaign-error?status=${validation.status}&message=${encodeURIComponent(validation.message || '')}&shortCode=${shortCode}`
  );
};
